<script setup lang="ts">
import ImageSlider from '@/components/reverse-slider/ImageSlider.vue'
import type { Image } from '@/types/ReverseSlider'
import useImageSlider from '@/lib/useImageSlider'

const props = defineProps<{
	images: Image[]
	secondImages: Image[]
}>()

const { sliderRef, translateX } = useImageSlider()
</script>

<template>
	<div ref="sliderRef" class="flex flex-col gap-16px overflow-hidden">
		<ImageSlider :images="images" :is-positive="true" v-model="translateX" />
		<ImageSlider
			:images="secondImages"
			:is-positive="false"
			v-model="translateX"
		/>
	</div>
</template>
